var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonActions from "@redux/feature/Markets/Common/actions/commonActions";
import { DRIVING_MKT_CLEAR_MSG, DRIVING_MKT_SET_MSG, SET_PARAMS, } from "../../interface/drivingMarket/iOptionDrivingMarketParams";
var DrivingMarketParamActions = /** @class */ (function (_super) {
    __extends(DrivingMarketParamActions, _super);
    function DrivingMarketParamActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DrivingMarketParamActions.prototype.setTabsMsg = function (reducerName, type, message) {
        this.dispatch({
            type: DRIVING_MKT_SET_MSG,
            reducerName: reducerName,
            callPutType: type,
            callPutMsg: message,
        });
    };
    DrivingMarketParamActions.prototype.removeTabsMsg = function (type, reducerName) {
        this.dispatch({
            type: DRIVING_MKT_CLEAR_MSG,
            reducerName: reducerName,
            callPutType: type,
        });
    };
    DrivingMarketParamActions.prototype.setParams = function (params, reducerName) {
        this.dispatch({
            type: SET_PARAMS,
            payload: params,
            reducerName: reducerName,
        });
    };
    return DrivingMarketParamActions;
}(CommonActions));
export default DrivingMarketParamActions;
